import React, { useState } from 'react';
import professional from '../assets/professional.svg'
import brain from '../assets/brain.svg'
import student from '../assets/student.svg'
import creator from '../assets/creator.svg'

const UsageSection = () => {
  const [activeCard, setActiveCard] = useState(null);

  const usageCards = [
    {
      icon: professional,
      title: "Academics & Professionals",
      subtitle: "Research & Analysis",
      description: "Break down complex topics with visualized layers of information to streamline research. Dive deeper into niche areas and find relevant resources.",
      color: "#00c6ff"
    },
    {
      icon: creator,
      title: "Content Creators",
      subtitle: "Content Research",
      description: "Simplify your content research process by exploring the breadth of topics. Access comprehensive overviews to create content that's insightful and well-informed.",
      color: "#00ff87"
    },
    {
      icon: student,
      title: "Educators & Students",
      subtitle: "Learning & Teaching",
      description: "Simplify learning with structured knowledge maps in an intuitive way. Save and revisit results for continuous exploration.",
      color: "#ff3366"
    },
    {
      icon: brain,
      title: "Curious Minds",
      subtitle: "Knowledge Discovery",
      description: "Explore those itches of curiosity in a structured way. Navigate the rabbit hole of information effortlessly.",
      color: "#ff9900"
    }
  ];

  return (
    <div style={styles.section}>
      <h2 style={styles.heading}>How people are using DeepNode</h2>
      
      <div style={styles.cardContainer}>
        {usageCards.map((card, index) => (
          <div
            key={index}
            style={{
              ...styles.card,
              borderColor: activeCard === index ? card.color : 'rgba(255,255,255,0.1)'
            }}
            className="usage-card"
            onMouseEnter={() => setActiveCard(index)}
            onMouseLeave={() => setActiveCard(null)}
          >
            <div style={styles.iconContainer} className="icon-container">
              <div style={{
                ...styles.iconBackground,
                background: activeCard === index ? card.color : 'rgba(255,255,255,0.1)'
              }} />
              <img src={card.icon} alt={card.title} style={styles.icon} />
            </div>

            <div style={styles.contentContainer}>
              <h3 style={styles.cardTitle}>{card.title}</h3>
              <span style={{
                ...styles.subtitle,
                color: card.color
              }}>{card.subtitle}</span>
              <p style={styles.description}>{card.description}</p>
            </div>

            <div style={{
              ...styles.cardDecoration,
              background: `linear-gradient(135deg, ${card.color}22 0%, transparent 100%)`
            }} className="card-decoration" />
          </div>
        ))}
      </div>

      <style>
        {`
          .usage-card {
            transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
            position: relative;
            overflow: hidden;
          }

          .usage-card:hover {
            transform: translateY(-8px);
            box-shadow: 0 20px 40px rgba(0,0,0,0.4);
          }

          .icon-container {
            transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
          }

          .usage-card:hover .icon-container {
            transform: scale(1.1);
          }

          .card-decoration {
            transition: opacity 0.4s ease;
            opacity: 0;
          }

          .usage-card:hover .card-decoration {
            opacity: 1;
          }

          @media (max-width: 1200px) {
            .usage-card {
              width: calc(50% - 20px);
            }
          }

          @media (max-width: 768px) {
            .usage-card {
              width: 100%;
              margin-bottom: 20px;
            }
          }
        `}
      </style>
    </div>
  );
};

const styles = {
  section: {
    padding: '0px 20px',
    // background: '#000',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    position: 'relative',
    overflow: 'hidden'
  },
  heading: {
    fontSize: 'clamp(24px, 4vw, 36px)',
    fontWeight: '400',
    color: '#fff',
    // textAlign: 'center',
    marginBottom: '80px',
    fontFamily: "'Poppins', sans-serif"
  },
  cardContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '30px',
    width: '100%',
    maxWidth: '1400px',
    margin: '0 auto',
    justifyContent: 'center',
  },
  card: {
    width: 'calc(25% - 12px)',
    minWidth: '260px',
    background: 'rgba(20, 20, 20, 0.8)',
    borderRadius: '20px',
    padding: '25px',
    border: '1px solid',
    backdropFilter: 'blur(10px)',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    alignItems: 'flex-start',
  },
  iconContainer: {
    position: 'relative',
    width: '48px',
    height: '48px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'flex-start'
  },
  iconBackground: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    borderRadius: '16px',
    transition: 'all 0.4s ease'
  },
  icon: {
    width: '24px',
    height: '24px',
    position: 'relative',
    zIndex: 1
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    alignItems: 'flex-start',
  },
  cardTitle: {
    fontSize: '20px',
    fontWeight: '200',
    color: '#fff',
    margin: 0,
    fontFamily: "'Poppins', sans-serif"
  },
  subtitle: {
    fontSize: '14px',
    fontWeight: '400',
    letterSpacing: '1px',
    textTransform: 'uppercase'
  },
  description: {
    textAlign: 'left',
    fontSize: '15px',
    lineHeight: '1.6',
    color: 'rgba(255,255,255,0.7)',
    margin: '10px 0 0 0',
    fontFamily: "'Poppins', sans-serif",
  },
  cardDecoration: {
    position: 'absolute',
    top: 0,
    right: 0,
    width: '100%',
    height: '100%',
    pointerEvents: 'none'
  }
};

export default UsageSection;